// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
const API_URL = 'https://api.vanillasky.ge';

export const environment = {
  production: false,
  apiUrl: API_URL,
  locationUrl: API_URL + '/locations',
  branchUrl: API_URL + '/branches',
  aircraftUrl: API_URL + '/aircrafts',
  flightGroupUrl: API_URL + '/flight_groups',
  flightUrl: API_URL + '/flights',
  logUrl: API_URL + '/logs',
  flightBulkUrl: API_URL + '/flight-groups-bulk-create',
  flightDetailsUrl: API_URL + '/flight-details',
  changeSeatsUrl: API_URL + '/change-seats',
  ticketUrl: API_URL + '/tickets',
  checkTicketUrl: API_URL + '/check-tickets',
  holdTicketUrl: API_URL + '/hold-tickets',
  unHoldTicketUrl: API_URL + '/hold-remove',
  usersUrl: API_URL + '/users',
  authUrl: API_URL + '/login_check',
  exportUrl: API_URL + '/export/tickets',
  itemsPerPage: 50
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts